<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="订单序列号" prop="orderSeqNo">
                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入订单序列号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="用户ID" prop="registerId">
                <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户ID" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="作品名称" prop="workFullName">
                <Input type="text" v-model="searchForm.workFullName" placeholder="请输入作品名称" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="作者" prop="authorNames">
                <Input type="text" v-model="searchForm.authorNames" placeholder="请输入作者名称," clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="著作权人" prop="powerNames">
                <Input type="text" v-model="searchForm.powerNames" placeholder="请输入著作权人" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="订单状态" prop="status">
                <Select v-model="searchForm.status" placeholder="请选择" clearable style="width: 200px">
                  <Option value="un_audit">待审核</Option>
                  <Option value="un_to_register">预登记中</Option>
                  <Option value="wait_identify">预登记完成</Option>
                  <Option value="identifying">版权登记中</Option>
                  <Option value="identify">版权登记完成</Option>
                  <Option value="reject_enable">驳回可编辑</Option>
                  <Option value="reject_disable">驳回不可编辑</Option>
                </Select>
              </Form-item>
<!--              <Form-item label="预登记证书状态" prop="preRegisterStatus">
                <Select v-model="searchForm.preRegisterStatus" placeholder="请选择" clearable style="width: 200px">
                  <Option value="0">未生成证书</Option>
                  <Option value="1">已生成证书</Option>
                </Select>
              </Form-item>-->
<!--                <Form-item label="登记证书状态" prop="registerStatus">
                <Select v-model="searchForm.registerStatus" placeholder="请选择" clearable style="width: 200px">
                  <Option value="0">未下证</Option>
                  <Option value="1">已下证</Option>
                </Select>
              </Form-item>-->
              <Form-item label="申请登记状态" prop="applyStatus">
                <Select v-model="searchForm.applyStatus" placeholder="请选择" clearable style="width: 200px">
                  <Option value="0">未申请登记</Option>
                  <Option value="1">已申请登记</Option>
                </Select>
              </Form-item>
              <!--<Form-item label="重新提交" prop="resubmit">
                <Select v-model="searchForm.resubmit" placeholder="请选择" clearable style="width: 200px">
                  <Option value="0">否</Option>
                  <Option value="1">是</Option>
                </Select>
              </Form-item>-->
              <Form-item label="办理周期" prop="urgentDayType">
                <Select v-model="searchForm.urgentDayType" placeholder="请选择" clearable style="width: 200px">
                  <Option value="1601">1工作日下证</Option>
                  <Option value="1602">3工作日下证</Option>
                  <Option value="1603">5工作日下证</Option>
                </Select>
              </Form-item>
              <Form-item label="提交订单时间" prop="createDate">
                <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
              </Form-item>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="orderExport" type="primary" icon="ios-search">根据查询条件导出</Button>
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
<!--                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>-->
              </Form-item>
            </Form>
          </Row>
<!--          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>-->
<!--          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>-->
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="订单状态" prop="status" >
          <Select
              v-model="form.status"
              placeholder="请选择"
              clearable
              style="width: 200px"
          >
            <Option value="审核通过" selected="selected">发往版权局</Option>
            <Option value="驳回可编辑">驳回可编辑</Option>
            <Option value="驳回不可编辑">驳回不可编辑</Option>
          </Select>
        </FormItem>
        <FormItem label="审核原因" prop="auditMsg" >
          <Input v-model="form.auditMsg" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>

    <Modal title="详情" v-model="detailModalVisible" :mask-closable='false' :width="1000">
      <Form ref="infoForm" :model="infoForm" :label-width="100" :rules="formValidate" >
        <table class="detailTable" >
          <tr v-if= "(infoForm.copyrightOrder.status == '待审核' && this.auditOrDetail == 1)" >
            <td colspan="85" style="text-align: center;">
              驳回原因：<Input v-model="rejectReason" maxlength="200" style="width: 400px;"/>
            </td>
          </tr>
          <tr v-if= "(infoForm.copyrightOrder.status == '待审核' && this.auditOrDetail == 1)" >
            <td colspan="5" style="text-align: center;">
              <Button type="primary" @click="handleSubmit(infoForm.copyrightOrder.orderSeqNo, '审核通过')">审核通过</Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button type="error" @click="handleSubmit(infoForm.copyrightOrder.orderSeqNo, '驳回不可编辑')">驳回<font size="3">(不可)</font>编辑</Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button type="error" @click="handleSubmit(infoForm.copyrightOrder.orderSeqNo, '驳回可编辑')">驳回<font size="3">(可)</font>编辑</Button>
            </td>
          </tr>

          <tr>
            <td rowspan="4" width="10%" style="text-align: center;vertical-align: middle;">作品基本信息</td>
            <td width="15%">订单ID</td>
            <td width="30%">{{this.infoForm.copyrightOrder.id }}</td>
            <td width="15%">订单号</td>
            <td width="30%">{{this.infoForm.copyrightOrder.orderSeqNo}}</td>
          </tr>
<!--          <tr>
            <td width="15%">第三方订单ID</td>
            <td width="30%" style="word-break: break-word;">{{this.infoForm.order.thirdOrderId}}</td>
            <td width="15%">订单来源平台</td>
            <td width="30%">{{this.infoForm.order.saasAppKey}}</td>
          </tr>
          <tr>
            <td width="15%">第三方用户ID</td>
            <td width="30%" style="word-break: break-word;">{{this.infoForm.order.thirdUserId}}</td>
            <td width="15%">用户序列号</td>
            <td width="30%">{{this.infoForm.order.saasRegisterSeqNo}}</td>
          </tr>-->
          <tr>
            <td width="15%">订单状态</td><td width="30%">{{this.infoForm.copyrightOrder.status}}</td>
            <td width="15%">是否重新提交</td><td width="30%">{{this.YESNO[this.infoForm.copyrightOrder.resubmit]}}</td>
          </tr>
          <tr>
            <td width="15%">创建时间</td>
            <td width="30%">
              {{this.infoForm.copyrightOrder.createDate}}
            </td>
            <td width="15%">更新时间</td>
            <td width="30%">
              {{this.infoForm.copyrightOrder.updateDate}}
            </td>
          </tr>
<!--          <tr>
            <td rowspan="2" width="10%" style="text-align: center;vertical-align: middle;">
              加急信息
            </td>
            <td width="15%">操作类型</td><td width="30%">{{this.OPERATIONTYPE[this.infoForm.order.operationType]}}</td>
            <td width="15%">是否处理</td><td width="30%">{{this.YESNO[this.infoForm.order.isOperation]}}</td>
          </tr>-->
          <tr>
            <td width="15%">办理周期</td>
            <td width="30%" colspan="3">{{this.URGENTDAYTYPE[this.infoForm.copyrightOrder.urgentDayType]}}</td>
            <!--            <td width="15%">加急天数</td><td width="30%">{{this.infoForm.order.urgentDay}}</td>-->
          </tr>
          <tr>
            <td rowspan="9" width="10%" style="text-align: center;vertical-align: middle;">
              作品信息
            </td>
            <td width="15%">作品名称</td><td width="30%">{{this.infoForm.copyrightOrder.workFullName}}</td>
            <td width="15%">
              作品类型:
            </td>
            <td width="30%">
              <Tooltip placement="top-start" :content="infoForm.copyrightOrder.workType">
                {{this.WORKTYPE[this.infoForm.copyrightOrder.workType]}}
              </Tooltip>
              <Tooltip placement="top-start" v-if="infoForm.copyrightOrder.workCategory" :content="infoForm.copyrightOrder.workCategory">
                {{this.WORKCATEGORY[this.infoForm.copyrightOrder.workCategory]}}
              </Tooltip>
            </td>
          </tr>
          <tr>
            <td width="15%">作者名称</td><td width="30%">{{this.infoForm.copyrightOrder.authorNames}}</td>
            <td width="15%">著作权人名称</td><td width="30%">{{this.infoForm.copyrightOrder.powerNames}}</td>
          </tr>
          <tr>
<!--            <td width="15%">创作性质</td><td width="30%">{{this.CREATIVETYPES[this.infoForm.copyrightOrderInfo.creativeType]}}</td>-->
            <td width="15%">创作性质</td><td width="30%">{{this.infoForm.copyrightOrderInfo.creativeType}}</td>
            <td width="15%">修改次数</td><td width="30%">{{this.infoForm.copyrightOrder.number}}</td>
          </tr>
          <tr>
            <td width="15%">创作性质说明</td>
            <td width="30%">{{this.CREATIVEPROPERTYSTATEMENT[this.infoForm.copyrightOrderInfo.creativePropertyStatement]}} </td>
            <td width="15%">授权书</td>
            <td width="30%">
              <a :href="''+infoForm.copyrightOrderInfo.creativeStatementUrl+''" v-if="infoForm.copyrightOrderInfo.creativeStatementUrl" target="_blank">授权书</a>
              <div v-else>-</div>
            </td>
          </tr>
          <tr>
            <td width="15%">创作过程</td>
            <td colspan="4">{{this.infoForm.copyrightOrderInfo.creationProcess}} </td>
          </tr>
          <tr>
            <td width="15%">创作开始时间</td><td width="30%">{{this.infoForm.copyrightOrderInfo.completeDateBegin|formatDate('yyyy-MM-dd')}}
            <td width="15%">创作完成时间</td><td width="30%">{{this.infoForm.copyrightOrderInfo.completeDateEnd|formatDate('yyyy-MM-dd')}}</td>
          </tr>
          <tr>
            <td width="15%">创作地点</td><td width="30%">{{this.infoForm.copyrightOrderInfo.completeCountry}}-{{this.infoForm.copyrightOrderInfo.completeProvince}}-{{this.infoForm.copyrightOrderInfo.completeCity}}</td>
            <td width="15%">发表状态</td>
            <td width="30%">{{this.PUBLISHSTATUS[this.infoForm.copyrightOrderInfo.publishStatus]}}</td>
          </tr>
          <tr>
            <td width="15%">链接地址或发表处</td>
            <td width="30%" colspan="3">{{infoForm.copyrightOrderInfo.publishUrl}}
<!--              <a :href="''+infoForm.copyrightOrderInfo.publishUrl+''" v-if="infoForm.copyrightOrderInfo.publishUrl" target="_blank">发表地址url</a>-->
            </td>
          </tr>
          <tr>
            <td width="15%">首次发表时间</td>
            <td width="30%" v-if="this.infoForm.copyrightOrderInfo.publishDate != null">{{this.infoForm.copyrightOrderInfo.publishDate|formatDate('yyyy-MM-dd')}}</td>
            <td width="30%" v-else></td>
            <td width="15%">首次发表地点</td><td width="30%">{{this.infoForm.copyrightOrderInfo.publishCountry}}-{{this.infoForm.copyrightOrderInfo.publishProvince}}-{{this.infoForm.copyrightOrderInfo.publishCity}}</td>
          </tr>
          <tr>
            <td width="15%" style="text-align: center;vertical-align: middle;">作品附件</td>
            <td colspan="4">
              <span v-for="(n,i) in (infoForm.copyrightOrder.url || '').split(',')" style="padding-right: 10px;"><a rel="noreferrer noopener nofollow" :href="''+n+''" target="_blank">附件{{i+1}}</a></span>
            </td>
          </tr>

          <tr>
            <td rowspan="2" width="10%" style="text-align: center;vertical-align: middle;">
              材料信息
            </td>
            <td width="15%">作品证明文件</td>
            <td colspan="3">
              <a :href="''+infoForm.copyrightOrderInfo.workCorporate+''" v-if="infoForm.copyrightOrderInfo.workCorporate"  target="_blank">{{this.infoForm.copyrightOrderInfo.workCorporate}}</a>
              <div v-else>-</div>
            </td>
          </tr>
          <tr>
            <td width="15%">其他材料信息</td>
            <td colspan="3">
              <div v-if="infoForm.copyrightOrderInfo.otherAttachments">
                    <span style="display: block" v-for="(url,i) in infoForm.copyrightOrderInfo.otherAttachments.split(',')">
                        <a :href="''+url+''" target="_blank" style="word-wrap:break-word">{{url}}</a>
                    </span>
              </div>
              <div v-else>-</div>
            </td>
          </tr>

          <tr>
            <td rowspan="4" width="10%" style="text-align: center;vertical-align: middle;">
              权利信息
            </td>
            <td width="15%" style="vertical-align: middle;">作者信息</td>
            <td colspan=3>
              <table class="table table-bordered" style="text-align:center">
                <tr>
                  <td style="width:20%">姓名或名称</td>
                  <td style="width:7%">类别</td>
                  <td style="width:8%">证件类型</td>
                  <td style="width:15%">证件号码</td>
                  <td style="width:5%">国籍</td>
                  <td style="width:5%">省份</td>
                  <td style="width:5%">城市</td>
                  <td style="width:10%">附件</td>
                </tr>
                <tr v-for="(entity,i) in infoForm.authorPeopleList">
                  <td>{{entity.name}}</td>
                  <td>
                    <span v-if="entity.peopleType == 'enterprise'">企业</span>
                    <span v-if="entity.peopleType == 'person'">个人</span>
                  </td>
                  <td>
                    <span v-if="entity.identityType == 'identity_card'">身份证</span>
                    <span v-if="entity.identityType == 'business_license'">营业执照</span>
                  </td>
                  <td>{{entity.identityNo}}</td>
                  <td>{{entity.country}}</td>
                  <td>{{entity.province}}</td>
                  <td>{{entity.city}}</td>
                  <td>
                    <a rel="noreferrer noopener nofollow" :href="''+entity.idFrontUrl+''" v-if="entity.idFrontUrl" target="_blank">身份证头像面<br/><br/></a>
                    <a rel="noreferrer noopener nofollow" :href="''+entity.idBackUrl+''" v-if="entity.idBackUrl" target="_blank">身份证国徽面<br/></a>
                    <a rel="noreferrer noopener nofollow" :href="''+entity.compoundImgUrl+''" v-if="entity.compoundImgUrl" target="_blank">合成照片地址<br/></a>
                    <a rel="noreferrer noopener nofollow" :href="''+entity.busiLicenseUrl+''" v-if="entity.busiLicenseUrl" target="_blank">营业执照<br/></a>
<!--                    <a rel="noreferrer noopener nofollow" :href="''+entity.legalIdFrontUrl+''" v-if="entity.legalIdFrontUrl" target="_blank">法人身份证正面<br/></a>
                    <a rel="noreferrer noopener nofollow" :href="''+entity.legalIdBackUrl+''" v-if="entity.legalIdBackUrl" target="_blank">法人身份证反面<br/></a>-->
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td width="15%" style="vertical-align: middle;">权利人信息</td>
            <td colspan=3>
              <table class="table table-bordered" style="text-align:center">
                <tr>
                  <td style="width:20%">姓名或名称</td>
                  <td style="width:7%">类别</td>
                  <td style="width:8%">证件类型</td>
                  <td style="width:15%">证件号码</td>
                  <td style="width:5%">国籍</td>
                  <td style="width:5%">省份</td>
                  <td style="width:5%">城市</td>
                  <td style="width:10%">附件</td>
                </tr>
                <tr v-for="(entity,i) in infoForm.obligeePeopleList">
                  <td>{{entity.name}}</td>
                  <td>
                    <span v-if="entity.peopleType == 'enterprise'">企业</span>
                    <span v-if="entity.peopleType == 'person'">个人</span>
                  </td>
                  <td>
                    <span v-if="entity.identityType == 'identity_card'">身份证</span>
                    <span v-if="entity.identityType == 'business_license'">营业执照</span>
                  </td>
                  <td>{{entity.identityNo}}</td>
                  <td>{{entity.country}}</td>
                  <td>{{entity.province}}</td>
                  <td>{{entity.city}}</td>
                  <td>
                    <a :href="''+entity.idFrontUrl+''" v-if="entity.idFrontUrl" target="_blank">身份证头像面<br/><br/></a>
                    <a :href="''+entity.idBackUrl+''" v-if="entity.idBackUrl" target="_blank">身份证国徽面<br/></a>
                    <a :href="''+entity.compoundImgUrl+''" v-if="entity.compoundImgUrl" target="_blank">合成照片地址<br/></a>
                    <a :href="''+entity.busiLicenseUrl+''" v-if="entity.busiLicenseUrl" target="_blank">营业执照<br/></a>
<!--                    <a :href="''+entity.legalIdFrontUrl+''" v-if="entity.legalIdFrontUrl" target="_blank">法人身份证正面<br/></a>
                    <a :href="''+entity.legalIdBackUrl+''" v-if="entity.legalIdBackUrl" target="_blank">法人身份证反面<br/></a>-->
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td width="15%">权利获得方式</td>
            <td width="30%">{{this.POWERBYS[this.infoForm.copyrightOrderInfo.powerBy]}}</td>
            <td width="15%">权利归属方式</td>
<!--            <td width="30%">{{this.COPYRIGHTTYPES[this.infoForm.copyrightOrder.copyrightType]}}</td>-->
            <td width="30%">{{this.infoForm.copyrightOrder.copyrightType}}</td>
          </tr>
          <tr>
            <td width="15%">权利范围</td>
            <td colspan=3>
                  <span style="padding-right: 10px" v-for="(scope,i) in (infoForm.copyrightOrderInfo.powerScope || '').split(',')">
                    <spam v-if="scope == '1'">发表权</spam>
                    <spam v-if="scope == '2'">署名权</spam>
                    <spam v-if="scope == '3'">修改权</spam>
                    <spam v-if="scope == '4'">保护作品完整权</spam>
                    <spam v-if="scope == '5'">复制权</spam>
                    <spam v-if="scope == '6'">发行权</spam>
                    <spam v-if="scope == '7'">出租权</spam>
                    <spam v-if="scope == '8'">展览权</spam>
                    <spam v-if="scope == '9'">表演权</spam>
                    <spam v-if="scope == '10'">放映权</spam>
                    <spam v-if="scope == '11'">广播权</spam>
                    <spam v-if="scope == '12'">信息网络传播权</spam>
                    <spam v-if="scope == '13'">摄制权</spam>
                    <spam v-if="scope == '14'">改编权</spam>
                    <spam v-if="scope == '15'">翻译权</spam>
                    <spam v-if="scope == '16'">汇编权</spam>
                    <spam v-if="scope == '17'">其他</spam>
                    <spam v-if="scope == '18'">全部权利</spam>
                  </span>
            </td>
          </tr>

          <!--
          <tr>
            <td width="10%" style="text-align: center;vertical-align: middle;">历史驳回原因</td>
            <td colspan="4">
                <div v-for="(historyEntity,i) in historyList">
                    时间：{{historyEntity.createDate}}  原因：{{historyEntity.auditReason}}  <a @click='showHistoryDetail(JSON.parse(historyEntity.auditBefore)["id"])'>详情</a>
                </div>
            </td>
          </tr>
          -->
          <tr>
            <td width="10%" style="text-align: center;vertical-align: middle;">驳回原因</td>
            <td colspan="4">{{infoForm.copyrightOrder.auditMsg}}</td>
          </tr>

          <tr>
            <td colspan="5"></td>
          </tr>

          <tr>
            <td rowspan="3" width="20%" style="text-align: center;vertical-align: middle;">
              预登记证书信息
            </td>
          </tr>
          <tr>
            <td width="10%">证书状态</td><td width="10%" v-if="this.infoForm.beforeCopyrightCert != null">{{this.CERTSTATUS[""+this.infoForm.beforeCopyrightCert.certStatus]}}</td>
            <td width="10%">证书编码</td><td width="40%" v-if="this.infoForm.beforeCopyrightCert != null">{{this.infoForm.beforeCopyrightCert.certCode}}</td>
          </tr>
          <tr>
            <td width="10%">下证时间</td><td width="10%" v-if="this.infoForm.beforeCopyrightCert != null">{{this.infoForm.beforeCopyrightCert.certTime}}</td>
            <td width="10%">证书地址</td><td width="40%" v-if="this.infoForm.beforeCopyrightCert != null"><a v-if="infoForm.beforeCopyrightCert.certUrl" :href="''+infoForm.beforeCopyrightCert.certUrl+''" target="_blank">证书地址</a><div v-else>-</div></td>
          </tr>
<!--          <tr>
            <td width="10%">回调第三方状态</td><td width="10%" v-if="this.infoForm.beforeCopyrightCert != null">{{this.SENDSTATUS[this.infoForm.beforeCert.callbackStatus]}}</td>
            <td width="10%">回调第三方次数</td><td width="40%" v-if="this.infoForm.beforeCopyrightCert != null">{{this.infoForm.beforeCert.callbackNumber}}</td>
          </tr>
          <tr>
            <td width="15%">返回信息</td>
            <td colspan="3">
              <div style="word-break:break-all;" v-for="(entity,i) in infoForm.beforeCallbackLogs" v-if="infoForm.beforeCallbackLogs"><b>{{i+1}}、回调时间：{{entity.createDate}}</b><br/>{{entity.callbackMessage}}</div>
            </td>
          </tr>-->

          <tr>
            <td colspan="5"></td>
          </tr>
          <tr>
            <td rowspan="3" width="10%" style="text-align: center;vertical-align: middle;">
              预登记订单发送中台信息
            </td>
          </tr>
          <tr>
            <td width="15%">发送中台状态</td><td width="30%" v-if="this.infoForm.beforeCopyrightInitialSend != null">{{this.SENDSTATUS[this.infoForm.beforeCopyrightInitialSend.status]}}</td>
            <td width="15%">发送次数</td><td width="30%" v-if="this.infoForm.beforeCopyrightInitialSend != null">{{this.infoForm.beforeCopyrightInitialSend.number}}</td>
          </tr>
          <tr>
            <td width="15%" style="vertical-align: middle;">返回信息</td>
            <td colspan="3" width="50%">
              <div style="word-break:break-all;" v-for="(entity,i) in infoForm.beforeCopyrightInitialSendLog" v-if="infoForm.beforeCopyrightInitialSendLog"><b>{{i+1}}、发送时间：{{entity.createDate}}</b><br/>{{entity.message}}</div>
            </td>
          </tr>

<!--          <tr>
            <td colspan="5"></td>
          </tr>-->
          <tr>
            <td rowspan="6" width="10%" style="text-align: center;vertical-align: middle;">
              登记证书信息
            </td>
          </tr>
          <tr>
            <td width="15%">证书登记状态</td><td width="30%">{{this.CERTFLAG[this.infoForm.copyrightOrderCert.certFlag]}}</td>
            <td width="15%">证书编码</td><td width="30%">{{this.infoForm.copyrightOrderCert.certCode}}</td>
          </tr>
          <tr>
            <td width="15%">证书地址</td>
            <td colspan="3">
              <a v-if="infoForm.copyrightOrderCert.certUrl" :href="''+infoForm.copyrightOrderCert.certUrl+''" target="_blank">证书地址</a>
              <div v-else>-</div>
            </td>
          </tr>
          <tr>
            <td width="15%">版权局驳回原因</td>
            <td colspan="3">
              {{this.infoForm.copyrightOrderCert.rejectReason}}
            </td>
          </tr>
          <tr>
            <td width="15%">审核状态</td>
            <td colspan="3">
              {{this.ORDERSTATUS[this.infoForm.copyrightOrderCert.auditStatus]}}
            </td>
          </tr>
          <tr>
            <td width="15%">审核原因</td>
            <td colspan="3">
              {{this.infoForm.copyrightOrderCert.auditMsg}}
            </td>
          </tr>
<!--          <tr>
            <td width="15%">回调第三方状态</td><td width="30%">{{this.SENDSTATUS[this.infoForm.cert.callbackStatus]}}</td>
            <td width="15%">回调第三方次数</td><td width="30%">{{this.infoForm.cert.callbackNumber}}</td>
          </tr>
          <tr>
            <td width="15%">返回信息</td>
            <td colspan="3">
              <div v-for="(entity,i) in infoForm.callbackLogs" v-if="infoForm.callbackLogs">{{entity.createDate}}:{{entity.callbackMessage}}</div>
            </td>
          </tr>-->

<!--          <tr>
            <td colspan="5"></td>
          </tr>-->
          <tr>
            <td rowspan="4" width="10%" style="text-align: center;vertical-align: middle;">
              登记订单发送中台信息
            </td>
          </tr>
          <tr>
            <td width="15%">中台返回订单号</td>
            <td colspan="3">
              {{this.infoForm.copyrightOrderFinallySend.bzOrderSeqNo}}
            </td>
          </tr>
          <tr>
            <td width="15%" style="text-align: center;vertical-align: middle;">发送中台状态</td>
            <td width="15%" v-if="this.infoForm.copyrightOrderFinallySend != null" colspan="3">{{this.SENDSTATUS[this.infoForm.copyrightOrderFinallySend.status]}}
              <br><br>发送次数:{{this.infoForm.copyrightOrderFinallySend.number}}</td>
<!--            <td width="10%">
              <Button type="primary" @click="resend()" v-if="this.isThird == ''">手动发送</Button>
            </td>-->
          </tr>
          <tr>
            <td width="15%" style="text-align: center;vertical-align: middle;">返回信息</td>
            <td colspan="3">
              <div style="word-break:break-all;" v-for="(entity,i) in infoForm.copyrightOrderFinallySendLog" v-if="infoForm.copyrightOrderFinallySendLog"><b>{{i+1}}、发送时间：{{entity.createDate}}</b><br/>{{entity.message}}<br/></div>
            </td>
          </tr>

        </table>
      </Form>
      <div slot="footer">
        <Button type="text" @click="detailModalVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import $ from 'jquery';

//订单状态
const ORDERSTATUS = {
  'wait_identify':'待审核',
  'identifying':'审核中',
  'identifyWaitSend':'审核待发送',
  'identify':'审核通过',
  'reject_enable':'被驳回',
  'reject_disable':'驳回不可编辑',
}

//创作类型
const CREATIVETYPES = {
  'original':'原创',
  'adaptation':'改编',
  'translation':'翻译',
  'compilation':'汇编',
  'annotate':'注释',
  'arrange':'整理',
  'other':'其他',
}

//权利归属方式
const COPYRIGHTTYPES = {
  'personal':'个人作品',
  'collaboration':'合作作品',
  'corporate':'法人作品',
  'job':'职务作品',
  'commission':'委托作品',
}
//权利取得方式
const POWERBYS = {
  '1':'原始取得',
  '2':'承受',
  '3':'继承',
  '4':'其他',
}
//发表状态
const PUBLISHSTATUS = {
  '0':'未发表',
  '1':'已发表',
}
//权利范围
const POWERSCOPE = {
  '1':'发表权',
  '2':'署名权',
  '3':'修改权',
  '4':'保护作品完整权',
  '5':'复制权',
  '6':'发行权',
  '7':'出租权',
  '8':'展览权',
  '9':'表演权',
  '10':'放映权',
  '11':'广播权',
  '12':'信息网络传播权',
  '13':'摄制权',
  '14':'改编权',
  '15':'翻译权',
  '16':'汇编权',
  '17':'其他',
  '18':'全部权利',
}
//创作性质说明
const CREATIVEPROPERTYSTATEMENT = {
  'PublicArea':'改编、翻译、汇编、整理的原作品已进入公有领域',
  'PoliceAccept':'经过改编、翻译、汇编、整理的作品属于法律认可的不构成侵权的范围',
  'AuthFile':'获得原著作权人的授权书',
}
//人员类型
const PEOPLETYPE = {
  'enterprise':'企业',
  'person':'个人',
}
//证件类型
const IDENTITYTYPE = {
  'identity_card':'身份证',
  'business_license':'企业法人营业执照',
}
//作品类型
const WORKTYPE = {
  'text':'模型作品',
  'talk':'口述作品',
  'music':'音乐作品',
  'drama':'戏剧作品',
  'song':'曲艺作品',
  'dance':'舞蹈作品',
  'acrobatics':'杂技艺术作品',
  'art':'美术作品',
  'build':'建筑作品',
  'picture':'摄影',
  'movie':'电影',
  'media':'类似摄制电影方法创作的作品',
  'chart':'工程设计图、产品设计图',
  'map':'地图、示意图',
  'model':'模型',
  'soundRecording':'录音制品',
  'videotape':'录像制品',
  'other':'其他作品',
}
//作品类型
const WORKCATEGORY = {
  'picture':'图片',
  'text':'文字',
  'media':'视频',
  'music':'音频',
  'other':'其他',
}
//任务执行结果状态
const SENDSTATUS = {
  '-1':'暂不发送',
  '0':'等待发送',
  '1':'发送成功',
  '2':'发送失败'
}
//证书登记状态
const CERTFLAG = {
  '0':'登记失败',
  '1':'登记成功',
}
//预登记证书状态
const CERTSTATUS = {
  'initial':'初始化状态',
  'success':'证书生成成功',
  'failed':'证书生成失败',
  '':'未知',
}
//是否
const YESNO = {
  '0':'否',
  '1':'是',
}
//操作类型
const OPERATIONTYPE = {
  '1':'标准',
  '2':'加急',
}
//加急天数类型
const URGENTDAYTYPE = {
  '1603':'5工作日出证',
  '1602':'3工作日出证',
  '1601':'1工作日出证',
}
//回调状态
const CALLBACKSTATUS = {
  '-1':'暂不回调',
  '0':'等待回调',
  '1':'回调成功',
  '2':'回调失败'
}
export default {
  name: "copyrightOrder",
  components: {
  },
  data() {
    return {
      CALLBACKSTATUS,
      YESNO,
      OPERATIONTYPE,
      URGENTDAYTYPE,
      CREATIVETYPES,
      ORDERSTATUS,
      COPYRIGHTTYPES,
      POWERBYS,
      PUBLISHSTATUS,
      PEOPLETYPE,
      POWERSCOPE,
      CREATIVEPROPERTYSTATEMENT,
      IDENTITYTYPE,
      WORKTYPE,
      WORKCATEGORY,
      SENDSTATUS,
      CERTFLAG,
      CERTSTATUS,

      time:new Date(),
      rejectReason:"",
      auditOrDetail:"",

      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      detailModalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        status: "",
        preRegisterStatus: "",
        registerStatus: "",
        applyStatus: "",
        auditMsg: "",
        resubmit: "",
        urgentDayType: "",
        newestStatus: "",
        orderSeqNo: "",
      },
      infoForm: { // 添加或编辑表单对象初始化数据
        copyrightOrder:{},
        copyrightOrderCert:{},
        beforeCopyrightCert:{},
        beforeCopyrightInitialSend:{},
        beforeCopyrightInitialSendLog:[],
        copyrightOrderFinallySend:{},
        copyrightOrderFinallySendLog:[],
        copyrightOrderInfo:{},
        copyrightOrderWork:[],
        beforeCopyrightTsc:{},
        register:{},
        registerPowerUserPo:{},
        authorPeopleList:[],
        obligeePeopleList:[],
      },
      // 表单验证规则
      formValidate: {
        status: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
/*        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },*/
/*        {
          title: "订单类型   gansu 甘肃版权登记",
          key: "orderType",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "订单序列号",
          key: "orderSeqNo",
          minWidth: 220,
          sortable: false,
        },
        {
          title: "用户ID",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
/*        {
          title: "登记类型",
          key: "regType",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "作品类型",
          key: "workType",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "作品类型(大类类)：media、music、text、picture、other..",
          key: "workCategory",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "作品名称",
          key: "workFullName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单状态",
          key: "status",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利归属方式",
          key: "copyrightType",
          minWidth: 120,
          sortable: false,
        },

        /*{
          title: "register_power_user表id   多个用逗号分隔",
          key: "powerIds",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "著作权人名称",
          key: "powerNames",
          minWidth: 190,
          sortable: false,
        },
        /*{
          title: "register_power_user表id   多个用逗号分隔",
          key: "authorIds",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "作者名称",
          key: "authorNames",
          minWidth: 180,
          sortable: false,
        },
        {
          title: "办理周期",
          key: "urgentDayType",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "作品链接地址",
          key: "url",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品附件名称",
          key: "attachmentsNames",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品附件名称",
          key: "attachmentsSize",
          minWidth: 120,
          sortable: false,
        },*/
        /*{
          title: "运营是否可以审核  yes 可以审核   no 不可以审核",
          key: "canAudit",
          minWidth: 120,
          sortable: false,
        },*/
        /*{
          title: "审核类型 manual 手动审核，automatic 自动审核",
          key: "auditType",
          minWidth: 120,
          sortable: false,
        },*/
        /*{
          title: "预登记证书状态",
          key: "preRegisterStatus",
          minWidth: 130,
          sortable: false,
        },
        {
          title: "登记证书状态",
          key: "registerStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "申请登记状态",
          key: "applyStatus",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "审核原因",
          key: "auditMsg",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "重新提交",
          key: "resubmit",
          minWidth: 120,
          sortable: false,
        },
        /*{
          title: "操作类型  1标准 2加急",
          key: "operationType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否处理 0否 1是",
          key: "isOperation",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "登记付款状态unpay( 未支付 ), paid( 已支付 ), refund( 已退款 ), refunding( 退款中 ),regular-clearing( 第三方通过开放平台的方式是定期结算 );",
          key: "payStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预登记付款状态unpay( 未支付 ), paid( 已支付 ), refund( 已退款 ), refunding( 退款中 ),regular-clearing( 第三方通过开放平台的方式是定期结算 );",
          key: "prePayStatus",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            if (params.row.status == '待审核' && (params.row.urgentDayType != null && params.row.urgentDayType != '')) {
              return h("div", [
                h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.detail(params.row.orderSeqNo, 2);
                        }
                      }
                    },
                    "详情"
                ),
                h(
                    "Button",
                    {
                      props: {
                        type: "success",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.detail(params.row.orderSeqNo, 1);
                        }
                      }
                    },
                    "审核"
                )
              ]);
            }else{
              return h("div", [
                h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.detail(params.row.orderSeqNo, 2);
                        }
                      }
                    },
                    "详情"
                )
              ]);
            }
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    orderExport() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/copyrightOrder/export", this.searchForm, 'blob').then(response => {
        this.loading = false;
        var blob = new Blob([response])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '预登记订单.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象

        console.log(response);
      });
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = null;
      this.searchForm.endDate = null;
      this.searchForm.registerId = null;
      this.searchForm.urgentDayType = null;
      // 重新加载数据
      this.getDataList();
    },
    /*resend() {
      this.submitLoading = true;
      var params = {
        orderSeqNo: this.orderSeqNo
      }
      this.postRequest("/copyrightOrder/resend", params).then(res => {
        this.submitLoading = false;
        if (res.success) {
          this.$Message.success("操作成功");
        }
      });
    },*/
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      this.getRequest("/copyrightOrder/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit(orderSeqNo, status){
          let sta = '';
          if(status == '待审核'){
            this.$Message.warning("订单状态不能为空");
            return;
          }
          if(status == '审核通过'){
            sta = 'identify';
          }else if(status == '驳回可编辑'){
            sta = 'reject_enable';
            if(this.rejectReason == ''){
              this.$Message.warning("驳回原因不能为空");
              return;
            }
          }else if(status == '驳回不可编辑'){
            sta = 'reject_disable';
            if(this.rejectReason == ''){
              this.$Message.warning("驳回原因不能为空");
              return;
            }
          }
      this.form.id = this.infoForm.copyrightOrder.id;
      this.form.orderSeqNo = this.infoForm.copyrightOrder.orderSeqNo;
      this.form.newestStatus = sta;
      this.form.auditMsg = this.rejectReason;

      this.submitLoading = true;
      this.postRequest("/copyrightOrder/vertify", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success(res.result);
                // this.modalVisible = false;
                this.detailModalVisible = false;
                this.auditOrDetail = 2;
                this.rejectReason = '';
                this.getDataList();
              }
            });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    /*edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.detailModalVisible = true;
    },*/
    detail(orderSeqNo, auditOrDetail) {
      this.auditOrDetail = auditOrDetail;//1：审核   2：详情

      this.modalTitle = "详情";
      this.$refs.form.resetFields();
      this.getRequest("/copyrightOrder/getDetails?orderSeqNo=" + orderSeqNo).then(res => {

        if (res.code == 200) {
          this.detailModalVisible = true;

          this.infoForm = res.result;
        }else{
          this.$Message.error(res.message);
        }
      });

    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },


  filters:{
    formatDate: function (value, args) {
      var dt = new Date(value);
      if (args == 'yyyy-M-d') {// yyyy-M-d
        let year = dt.getFullYear();
        let month = dt.getMonth() + 1;
        let date = dt.getDate();
        return `${year}-${month}-${date}`;
      } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
        let year = dt.getFullYear();
        let month = dt.getMonth() + 1;
        let date = dt.getDate();
        let hour = dt.getHours();
        let minute = dt.getMinutes();
        let second = dt.getSeconds();
        return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
      } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
        let year = dt.getFullYear();
        let month = (dt.getMonth() + 1).toString().padStart(2, '0');
        let date = dt.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${date}`;
      } else {// yyyy-MM-dd HH:mm:ss
        let year = dt.getFullYear();
        let month = (dt.getMonth() + 1).toString().padStart(2, '0');
        let date = dt.getDate().toString().padStart(2, '0');
        let hour = dt.getHours().toString().padStart(2, '0');
        let minute = dt.getMinutes().toString().padStart(2, '0');
        let second = dt.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
      }
    }
  },

  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
  .operation {
    margin-bottom: 2vh;
  }
  .select-count {
    font-size: 13px;
    font-weight: 600;
    color: #40a9ff;
  }
  .select-clear {
    margin-left: 10px;
  }
  .page {
    margin-top: 2vh;
  }
  .drop-down {
    font-size: 13px;
    margin-left: 5px;
  }
}

.detailTable,.detailTable table{
  width: 100%;
  border: 1px solid #ddd;
  border-collapse: separate;
  *border-collapse: collapse;
  border-left: 0;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.detailTable tr{
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
  line-height: 17px;
  font-size: 17px;
}
.detailTable tr td{
  padding: 8px;
  line-height: 25px;
  text-align: left;
  vertical-align: top;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
}
</style>